import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemBody = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, styles.containerSM])];

  // ───────────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  containerXS: {
    paddingBottom: theme.spacing['25'],
  },
  containerSM: {
    paddingBottom: theme.spacing['25'],
  },
});
